import { render, staticRenderFns } from "./regist.vue?vue&type=template&id=048d7ff6"
import script from "./regist.vue?vue&type=script&lang=js"
export * from "./regist.vue?vue&type=script&lang=js"
import style0 from "./regist.vue?vue&type=style&index=0&id=048d7ff6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048d7ff6')) {
      api.createRecord('048d7ff6', component.options)
    } else {
      api.reload('048d7ff6', component.options)
    }
    module.hot.accept("./regist.vue?vue&type=template&id=048d7ff6", function () {
      api.rerender('048d7ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/regist.vue"
export default component.exports